import React from 'react'
import AdminProfile from "../components/AdminProfile/AdminProfile"

const AdminProfileSection =()=>{
    return(
       <AdminProfile />
    )
}

export default AdminProfileSection